import {
    Badge,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';
import { translate } from '../../../i18n';
import { GameRefundDto } from '../../../models/game/dto/game.dto';
import { RefundStatus } from '../../../models/game/dto/refund.dto';
import { formatDate } from '../GameDetailsPage';

interface Props {
    refunds: GameRefundDto[];
}

const RefundsCard: React.FC<Props> = ({ refunds }) => {
    const borderColor = useColorModeValue('gray.200', 'gray.600');

    if (refunds.length === 0) {
        return (
            <Text color="gray.500" textAlign="center" py={4}>
                {translate('game.no_refunds')}
            </Text>
        );
    }

    return (
        <TableContainer>
            <Table variant="simple" size="sm">
                <Thead>
                    <Tr>
                        <Th borderColor={borderColor}>User</Th>
                        <Th borderColor={borderColor}>{translate('game.status')}</Th>
                        <Th borderColor={borderColor}>{translate('game.payment_amount')}</Th>
                        <Th borderColor={borderColor}>{translate('game.refund_reason')}</Th>
                        <Th borderColor={borderColor}>{translate('game.booked_at')}</Th>
                        <Th borderColor={borderColor}>{translate('game.refund_processed_at')}</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {refunds.map((refund) => (
                        <Tr key={refund.id}>
                            <Td borderColor={borderColor}>
                                <Text fontSize="sm">{refund.userName}</Text>
                            </Td>
                            <Td borderColor={borderColor}>
                                <Badge
                                    colorScheme={
                                        refund.status === RefundStatus.SUCCESSFUL
                                            ? 'green'
                                            : refund.status === RefundStatus.FAILED
                                                ? 'red'
                                                : 'yellow'
                                    }
                                >
                                    {refund.status === RefundStatus.SUCCESSFUL
                                        ? translate('game.refund_status_successful')
                                        : refund.status === RefundStatus.FAILED
                                            ? translate('game.refund_status_failed')
                                            : translate('game.refund_status_retry')}
                                </Badge>
                            </Td>
                            <Td borderColor={borderColor}>
                                <Text fontSize="sm">{refund.amount.toFixed(2)} {refund.currency.toUpperCase()}</Text>
                            </Td>
                            <Td borderColor={borderColor}>
                                <Tooltip label={refund.reason} hasArrow>
                                    <Text fontSize="sm" maxW="200px" isTruncated>
                                        {refund.reason}
                                    </Text>
                                </Tooltip>
                            </Td>
                            <Td borderColor={borderColor}>
                                <Text fontSize="sm">{formatDate(refund.createdAt)}</Text>
                            </Td>
                            <Td borderColor={borderColor}>
                                <Text fontSize="sm">
                                    {refund.processedAt ? formatDate(refund.processedAt) : '-'}
                                </Text>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    );
};

export default RefundsCard;
